
export const Pages = [
        {
                path: `/`,
                name:`الرئيسية`,
                name_en:`الرئيسية`
        },
        {
                path: `services`,
                name:`الخدمات`,
                name_en:`الخدمات`
        },
        // {
        //         path: `projects`,
        //         name:`المشاريع`,
        //         name_en:`Projects`
        // },
        // {
        //         path: `blogs`,
        //         name:`المقالات`,
        //         name_en:`Our Blogs`
        // },
        // {
        //         path: `documents`,
        //         name: `الوثائق`,
        //         name_en: `الوثائق`
        // },
        {
                path: `about`,
                name: `من نحن`,
                name_en: `من نحن`
        },
        {
                path: `contact`,
                name:`تواصل معنا`,
                name_en:`تواصل معنا`
        },
]